import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { IChangeType, IResponseAuth } from '@pacifico/interfaces/auth-api.interface';
import { CURRENCY_VALUE } from '@pacifico/utils/enums';
import { SessionStorageService } from './storage/storage.service';

@Injectable({ providedIn: 'root' })
export class TypeChangeService {
	private _currentChangeType!: IChangeType;

	constructor(private _decimalPipe: DecimalPipe, private _sessionStorageService: SessionStorageService) {
		const jToken = this._sessionStorageService.getItem<IResponseAuth>('token')!;
		if (jToken) {
			this._currentChangeType = jToken.changeType;
		}
	}

	typeChange(mount: number, solesToDolar: boolean): number {
		return solesToDolar ? mount / this._currentChangeType.dollarSell : mount * this._currentChangeType.dollarBuy;
	}

	get changeType(): IChangeType {
		return this._currentChangeType;
	}

	set changeType(changeType: IChangeType) {
		this._currentChangeType = changeType;
	}

	getDollarSellFormat(): string {
		return this._decimalPipe.transform(this.changeType.dollarSell, '1.3-3')!;
	}

	getDollarBuyFormat(): string {
		return this._decimalPipe.transform(this.changeType.dollarBuy, '1.3-3')!;
	}

	getChangeType(codeCoin: number): number {
		return codeCoin === 1 ? this.changeType.dollarSell : this.changeType.dollarBuy;
	}

	/**
	 * 1 = SOLES
	 * 2= DOLARES
	 *
	 *  Si se manda el valor 1 quiere decir que se cambiara soles a dolares y por ende se aplica el precio de la venta de lo contrario se aplica el precio de la compra.
	 *
	 * @param codeCoin id de la moneda
	 * @returns el tipo de cambio aplicando el formato '1.2-2'
	 */
	getChangeTypeFormat(codeCoin: number): string {
		return codeCoin === CURRENCY_VALUE.SOLES ? this.getDollarSellFormat() : this.getDollarBuyFormat();
	}
}
